import Vue from "vue";
import mask from "./loading.vue"; // 引入loading实例
const Mask = Vue.extend(mask);
// 返回loadingService服务状态的实例  Loading.service()方式调用
export const Loading = (function() {
  let Service = function() {
    var div;
    var loadingMask;
    this.service = function() {
      div = document.createElement("div");
      let child = document.createElement("div");
      div.appendChild(child);
      document.body.appendChild(div);
      loadingMask = new Mask();
      loadingMask.visible = true;
      loadingMask.$mount(child);
    };
    this.close = function() {
      loadingMask.visible = false;
      document.body.removeChild(div);
    };
  };
  return new Service();
})();  // 自调用，这样return出来的就可以直接使用了，不用再运行一次



// WEBPACK FOOTER //
// ./src/components/loading/index.js